
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as MathsIconComponent } from "./maths-icon.svg";

export const MathsIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <MathsIconComponent {...props} />;
};
